import React, { useEffect, useRef, useState } from "react";
import styles from "./gstBAsedKyc.module.css";
import { useNavigate } from "react-router-dom";
import EntityBasedKyc from "../EntityBasedKyc/EntityBasedKyc";
import { useAllProduct } from "../../api-context/commonApiContext";
import Notification from "../../Notification/Notification";
import {
  Box,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Link,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import TermsAndConditions from "../../TermsAndCondition/TermsAndConditions";
import config from "../../../config/config";
import { CircularProgress } from "@mui/material";
import { useDebouncedLog } from "../../../useDebouncedLog";

const BASE_URL = "http://localhost:5050/api";

const GstBasedKyc = () => {
  const {
    companyId,
    setCompanyId,
    isAllowAdvancedKyc,
    setBasicKyc,
    basicKyc,
    phoneNo,
    setName,
    setPhoneNo,
    setEmail,
    name,
    affiliate_code,
    setAffiliate_code,
    email,
  } = useAllProduct();
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  const [isGstIn, setIsGstIn] = useState(true); //always True

  const [gstin, setGstin] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [verified, setVerified] = useState(false);
  const [details, setDetails] = useState(null);
  const [status, setStatus] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [modal, setModal] = useState(false);
  const [successNoti, setSuccessNoti] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const openedRef = useRef(false);

  const logBasicKycScreenVisited = useDebouncedLog(
    "admin_basic_kyc_screens_visited",
    500,
  );
  const logNonGstinBasicKyc = useDebouncedLog("admin_non_gstin_basic_kyc", 500);
  const logVerifyGstinBasicKyc = useDebouncedLog(
    "admim_verify_gstin_basic_kyc",
    500,
  );
  const logGstinBasicKyc = useDebouncedLog("admim_gstin_basic_kyc", 500);
  const logBasicKycCompleted = useDebouncedLog("admim_completed_basic_kyc", 500);

  useEffect(() => {
    logBasicKycScreenVisited();
  }, [logBasicKycScreenVisited]);
  useEffect(() => {
    console.log("comp-->", companyId);
    // if (!companyId) navigate("/");
  }, [companyId]);

  useEffect(() => {
    if (successNoti) setModal(false);
  }, [successNoti]);

  const resetGstinDerivedState = () => {
    setDetails(null);
    setVerified(false);
    setAgreed(false);
    setStatus("");
    setErrorMsg("");
  };

  const parseDetails = (payload = {}) => {
    const d = payload || {};
    return {
      entityType:
        d.entityType || d.entity_type || d.business_entity_type || d.ctb || "",
      companyName:
        d.companyName ||
        d.company_name ||
        d.corporate_name ||
        d.legal_name ||
        d.tradeName ||
        d.trade_name ||
        "",
      registeredAddress:
        d.registeredAddress ||
        d.registered_address ||
        d.address ||
        d.principal_place_of_business ||
        "",
      status: d.status || "",
    };
  };

  const handleVerify = async () => {
    setErrorMsg("");
    setVerified(false);
    setDetails(null);
    setStatus("");
    try {
      logVerifyGstinBasicKyc();
    } catch (err) {
      console.log("error", err);
    }
    const trimmed = gstin.trim().toUpperCase();
    if (!trimmed) return setErrorMsg("Please enter a GSTIN.");

    const GSTIN_RE =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!GSTIN_RE.test(trimmed))
      return setErrorMsg("Please enter a valid GSTIN.");

    try {
      setLoading(true);
      const res = await fetch(
        `${config.mock_api_endpoint}/basic-kyc/gstin-verify`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": process.env.REACT_APP_CUPI_API_KEY,
          },
          body: JSON.stringify({
            gstin: trimmed,
            company_id: companyId,
          }),
        },
      );

      const json = await res.json();
      if (!res.ok) throw new Error(json?.message || "GSTIN verify failed");

      const payload = json?.data ?? {};
      console.log("GSTIN verify payload--->", payload);

      const parsed = parseDetails(payload);
      setDetails(parsed);
      setStatus(parsed.status);

      if (
        parsed.status === "Active" &&
        (parsed.companyName || parsed.entityType || parsed.registeredAddress)
      ) {
        setVerified(true);
      }
      if (status === "Cancelled") {
        setErrorMsg(
          "This GSTIN is cancelled!. Try again with a new GSTIN number or proceed without GSTIN.",
        );
      }
    } catch (err) {
      console.error("POST /basic-kyc/gstin-verify failed:", err);
      setErrorMsg("Could not verify GSTIN. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleNext = async () => {
    if (!verified || status !== "Active" || !details) return;

    try {
      setSuccessNoti(true);

      const res = await fetch(
        `${config.mock_api_endpoint}/basic-kyc/company-details`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": process.env.REACT_APP_CUPI_API_KEY,
          },
          body: JSON.stringify({
            companyName: details.companyName,
            entityType: details.entityType,
            registeredAddress: details.registeredAddress,
            company_id: companyId,
            gstin: gstin,
            name: name,
            email: email,
            phone_no: phoneNo,
            affiliate_code: affiliate_code,
            trade_name: details?.trade_name
              ? details?.trade_name
              : details.companyName,
          }),
        },
      );

      const json = await res.json();
      console.log("json--->", json);

      if (!res.ok) {
        setSuccessNoti(false);
        throw new Error(json?.message || "Company details save failed");
      }
      try {
        if (isGstIn) {
          logGstinBasicKyc();
        } else {
          logNonGstinBasicKyc();
        }
        logBasicKycCompleted();
      } catch (err) {
        console.log("error", err);
      }
      // ✅ Success path
      isAllowAdvancedKyc(true);
      setBasicKyc(true);

      setCompanyId("");
      setName("");
      setPhoneNo("");
      setEmail("");
      setAffiliate_code("");
      localStorage.removeItem("company_id");
      localStorage.removeItem("phoneNo");
      localStorage.removeItem("email");
      localStorage.removeItem("name");

      if (json.redirect_url) {
        window.location.assign(
          `${config.redirect_base_url}${json.redirect_url}`,
        ); //same tab
        // window.open(`${config.redirect_base_url}${json.redirect_url}`); //new Tab
      }
    } catch (err) {
      setSuccessNoti(false);
      console.error("POST /basic-kyc/company-details failed:", err);

      const msg =
        err?.response?.data?.message || // axios-style error
        err?.message || // thrown error
        (typeof err === "string" ? err : null) ||
        "Could not save company details. Please try again.";

      setErrorMsg(msg);
    }
  };

  if (successNoti) {
    return (
      <div className={`${styles.wrapper} container`}>
        {/* <div className={styles.title}>Business Identification</div> */}
        {/* <hr /> */}
        <div
          style={{
            minHeight: "70vh",
            display: "grid",
            placeItems: "center",
            // padding: "16px",
          }}
        >
          <Notification />
        </div>
      </div>
    );
  }

  const nextDisabled = !agreed || !verified || status !== "Active" || loading;

  return (
    <div className={`${styles.wrapper} container`}>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress size={60} sx={{ color: "#2348AB" }} />
        </div>
      )}
      {!isGstIn && (
        <div className={styles.NoteContainer}>
          <div className={styles.Bold}>
            Verify your business by selecting your Business Entity type below:
          </div>
          <div>
            - For Private/Public Ltd, OPC, or Section 8 Companies,{" "}
            <span className={styles.Bold}>
              enter your CIN and click Verify.
            </span>
          </div>
          <div>- For LLPs, provide your LLPIN and click Verify.</div>
          <div>
            - For Partnership Firms, Trusts, or other entities, please enter
            your registered address as well.
          </div>
          <div className={styles.Bold}>
            Enter your Company PAN and click Verify.
          </div>
          <div>
            Make sure you agree to the{" "}
            <span className={styles.Bold}>CUPI T&C</span> before hitting the{" "}
            <span className={styles.Bold}>Submit button!</span>
          </div>
        </div>
      )}
      {isGstIn && (
        <div className={styles.NoteContainer}>
          {verified && details ? (
            <div>
              Make sure you agree to the{" "}
              <span className={styles.Bold}>CUPI T&C</span> before hitting the{" "}
              <span className={styles.Bold}>Submit button!</span>
            </div>
          ) : (
            <>
              {" "}
              <div className={styles.Bold}>
                Please help us verify your business.
              </div>
              {/* <br></br> */}
              <div>
                Submit your Business GSTIN below and click Verify.{" "}
                <span className={styles.Bold}>OR</span>
              </div>
              <div>
                If you don’t have a GSTIN, click on the “Continue without GSTIN”
                Button below.
              </div>
            </>
          )}
        </div>
      )}
      <div className={styles.title}>Business Identification</div>
      <hr />

      <div className={styles.content}>
        {isGstIn ? (
          <>
            {/* GSTIN input + verify */}
            <div className="d-flex justify-content-between mt-4 w-100 gap-2">
              <div style={{ width: "90%" }}>
                <TextField
                  className="w-100"
                  name="gstin"
                  label={
                    <>
                      GSTIN<span style={{ color: "red" }}> *</span>
                    </>
                  }
                  value={gstin}
                  onChange={(e) => {
                    const v = e.target.value.toUpperCase();
                    if (v.length <= 15) {
                      setGstin(v);
                      resetGstinDerivedState();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleVerify();
                  }}
                  variant="outlined"
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
                />
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <button
                  className={`${styles.verify} ${
                    verified ? styles.verifySuccess : ""
                  }`}
                  onClick={handleVerify}
                  disabled={loading || verified}
                  aria-busy={loading ? "true" : "false"}
                >
                  {loading ? (
                    "Verifying..."
                  ) : verified ? (
                    <div className="d-flex gap-2">
                      <img src="/verified.svg" alt="verified" />
                      <div>Verified</div>
                    </div>
                  ) : (
                    "Verify"
                  )}
                </button>
              </div>
            </div>

            {errorMsg && (
              <div style={{ color: "#d32f2f", fontSize: 13, marginTop: 8 }}>
                {errorMsg}
              </div>
            )}

            {/* <div className="mt-1">
              Don&apos;t have a GSTIN?{" "}
              <span
                style={{
                  textDecoration: "underline",
                  color: "#2348AB",
                  cursor: "pointer",
                }}
                onClick={() => setIsGstIn(false)}
              >
                Continue without GSTIN 
              </span>
            </div> */}

            {!verified && (
              <div className="mt-4">
                <span className={`${styles.borderBlue} p-4`}>
                  Don’t have GSTIN?{" "}
                  <button
                    className={`${styles.buttonBlue} px-2 mx-4`}
                    onClick={() => setIsGstIn(false)}
                  >
                    Continue without GSTIN{" "}
                  </button>
                </span>
              </div>
            )}

            {verified && details && (
              <>
                <div className={styles.infoSection}>
                  <div className={styles.infoRow}>
                    <div className={styles.label}>Business Entity Type</div>
                    <div className={styles.colon}>:</div>
                    <div className={styles.value}>
                      {details?.entityType || "-"}
                    </div>
                  </div>
                  <div className={styles.infoRow}>
                    <div className={styles.label}>Company Name</div>
                    <div className={styles.colon}>:</div>
                    <div className={styles.value}>
                      {details?.companyName || "-"}
                    </div>
                  </div>
                  <div className={styles.infoRow}>
                    <div className={styles.label}>Registered Address</div>
                    <div className={styles.colon}>:</div>
                    <div className={styles.value}>
                      {details?.registeredAddress || "-"}
                    </div>
                  </div>
                </div>

                <div className={`${styles.agreeWrap} mt-4`}>
                  <input
                    id="agree"
                    type="checkbox"
                    checked={agreed}
                    onChange={(e) => setAgreed(e.target.checked)}
                    required
                  />
                  <label htmlFor="agree" className={styles.agreeText}>
                    <b aria-hidden="true">*</b> I agree to the{" "}
                  </label>
                  <button
                    type="button"
                    className={styles.linkLike}
                    onClick={() => setModal(true)}
                    aria-haspopup="dialog"
                    aria-controls="terms-dialog"
                  >
                    Terms &amp; Conditions
                  </button>
                  .
                </div>
              </>
            )}
          </>
        ) : (
          <EntityBasedKyc />
        )}
      </div>

      {isGstIn && (
        <div className={styles.footer}>
          <div className={`${styles.nextBtn} d-flex justify-content-end`}>
            <button
              className="px-5 pt-2 pb-2"
              onClick={() => navigate("/basic-kyc")}
            >
              Back
            </button>
            <button
              className="px-5 pt-2 pb-2"
              onClick={handleNext}
              disabled={nextDisabled}
              title={
                !verified || status !== "Active"
                  ? "Please verify GSTIN (Active) first"
                  : ""
              }
            >
              Submit
            </button>
          </div>
        </div>
      )}
      <Dialog
        open={modal}
        onClose={() => setModal(false)}
        maxWidth="md"
        fullWidth
        aria-labelledby="cin-helper-title"
        slotProps={{
          paper: {
            sx: { borderRadius: 3, overflow: "hidden" }, // 3 ≈ 12px
            // variant: "outlined",                     // optional
            // elevation: 0,                            // optional
          },
        }}
      >
        <DialogTitle sx={{ p: 2 }}>
          <Box className="d-flex justify-content-between align-items-center">
            <Typography
              id="cin-helper-title"
              variant="h6"
              className={styles.modaltitle}
            >
              CUPI – Terms and Conditions
            </Typography>

            <img
              src="/x-circle.svg"
              onClick={() => setModal(false)}
              alt="close"
            />
          </Box>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 2 }}>
          <TermsAndConditions />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default GstBasedKyc;
